import { REPLACE, CLEAR, CLEAR_ARCHINGS_FILTERS, SET_PAGESIZE, SET_PAGENUMBER, SET_FILTERS, DELETE } from './actions';

const initialState = {
    closures: [],
    totalResults: 0,
    totalPage: 1,
    pageSize: 10,
    pageNumber: 1,
    filters: {
        cashRegisterId: '',
        from: '',
        to: '',
    },
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE:
            return {
                ...state,
                closures: action.closures,
                totalResults: action.totalResults,
                totalPage: action.totalPage,
            }
        case SET_PAGESIZE:
            return {
                ...state,
                pageSize: action.pageSize
            }
        case SET_PAGENUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber
            }
        case SET_FILTERS:
            return {
                ...state,
                pageNumber: 1,
                filters: {
                    ...state.filters,
                    ...action.filters
                },
            }
        case CLEAR:
            return initialState
        case CLEAR_ARCHINGS_FILTERS:
            return {
                ...state,
                pageNumber: initialState.pageNumber,
                filters: initialState.filters,
            }
        case DELETE:
            return {
                ...state,
            }
        default:
            return state;
    }
}